
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  thankYouHeadline: {
    id: "ThankYou.headline",
    defaultMessage: "Thank you for your configuration!",
  },
  thankYouMessage: {
    id: "ThankYou.message",
    defaultMessage: "We have sent you a confirmation email with all the details of your order.",
  },
  thankYouOrder: {
    id: "ThankYou.order",
    defaultMessage: "Your order number: ",
  },
  thankYouPdfButton: {
    id: "ThankYou.pdfbutton",
    defaultMessage: "Export as 2D PDF",
  },
  thankYouTenderDocuments: {
    id: "ThankYou.tenderdocuments",
    defaultMessage: "Tender Documents",
  },
  thankYouOverviewButton: {
    id: "ThankYou.overviewbutton",
    defaultMessage: "Go to configuration overview",
  },
  orderPdf: {
    id: "ThankYou.orderPdf",
    defaultMessage: "Order (PDF)",
  },
  manufacturingPdf: {
    id: "ThankYou.manufacturingPdf",
    defaultMessage: "2D view (PDF)",
  },
  troughPdf: {
    id: "ThankYou.troughPdf",
    defaultMessage: "Technical drawing trough (PDF)",
  }
});

export default MESSAGES;